import React, {useEffect} from 'react';
import {observer} from 'mobx-react-lite';

import LoadingImg from '../components/LoadingImg';
import ContentView from '../components/ui-controls/layout/ContentView';
import {AppRoute} from '../models/AppRoute';
import {RouteNavigatorScreenProps} from '../models/navigationTypes';
import {useStores} from '../stores/use-stores';

const StoreSwitchLinkScreen = observer(
  ({
    navigation,
    route,
  }: RouteNavigatorScreenProps<AppRoute.STORE_SWITCH_LINK>) => {
    const {shopSelectionStore} = useStores();

    const shopSalesForceId = route.params.shopSalesforceId;

    useEffect(() => {
      async function switchToStoreInLinkParam() {
        if (shopSalesForceId) {
          await shopSelectionStore.findSalesforceShop(shopSalesForceId);
          navigation.navigate(AppRoute.HOME);
        }
      }
      switchToStoreInLinkParam();
      // only once
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
      <ContentView>
        <LoadingImg />
      </ContentView>
    );
  },
);

export default StoreSwitchLinkScreen;
